import React from 'react';
import { CtaButton } from './CtaButton';
export function FinalCta() {
  return <section className="w-full bg-white py-10 md:py-16 px-6" data-id="element-82">
      <div className="max-w-3xl mx-auto text-center" data-id="element-83">
        <CtaButton text="Secure My Copy Now — $6.37" data-id="element-84" />
      </div>
    </section>;
}